import React, { ComponentProps, useState } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  Form,
  Input, Option,
  Row, Select,
  SelectParam,
  SonForm,
  SubmitButton, Textarea,
  TextAreaParam,
  TextParam,
  useForm,
} from '../../_lib/Form2';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { useNavigate } from 'react-router';
import { useDelayed } from '../../hooks/useDelayed';

type PageTemplateSettingsType = {
  views: {
    default: {
      embedded: {
        form: SonForm<SelectParam<'templateType', { value: 'none' | 'global' }>
        | TextParam<'title'>
        | TextAreaParam<'description'>>
      }
    }
  }
};

function PageTemplateSettings({ views }: PageTemplateSettingsType) {
  const { t } = useSonTranslation('PageTemplateSettings');
  const navigate = useNavigate();
  const delayedPageRefresh = useDelayed(() => {
    navigate(0);
  });

  const reloadPageOnSuccess = () => {
    delayedPageRefresh();
  };

  const { form } = views.default.embedded;
  const { formProps, fetchState, params } = useForm({ form, onSuccess: reloadPageOnSuccess });
  const templateType = params.getByName('templateType');
  const title = params.getByName('title');
  const description = params.getByName('description');

  const [selected, setSelected] = useState<'none' | 'global'>(templateType.value as 'none' | 'global');

  return (
    <Form id="page-template-settings-form" {...formProps}>
      <Row>
        <Select
          label={t('select.label')}
          param={templateType}
          onChange={event => setSelected(event.target.value as 'none' | 'global')}
        >
          {templateType.options.map(option => (
            <Option key={option.value} value={option.value}>
              {t(`select.options.${option.value}`)}
            </Option>
          ))}
        </Select>
      </Row>
      { selected && selected !== 'none'
        ? <>
            <Row>
              <Input label={t('titleLabel')} param={title} helpText={t('tileHelpText')} />
            </Row>
            <Row>
              <Textarea label={t('descriptionLabel')} param={description} helpText={t('descriptionHelpText')} />
            </Row>
          </>
        : null}
      <SubmitButton
        buttonLabel={t('submitButtonLabel')}
        messageSuccess={t('status.messageSuccess')}
        messageForward={t('status.messageForward')}
        messageSending={t('status.messageSending')}
        messageFail={t('status.messageFail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const PageTemplateSettingsBlock = asFetchableBlock(PageTemplateSettings, BlockType.pagetemplate);
export type PageTemplateSettingsBlock = ComponentProps<typeof PageTemplateSettingsBlock>;
